import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Retrait.css";

export default function Retrait() {
  const navigate = useNavigate();

  return (
    <div className="retrait-page">
      <div className="retrait-shell">

        <div className="retrait-header">
          <div>
            <h2 className="retrait-title">💸 Retirer des coins</h2>
            <p className="retrait-subtitle">
              Choisissez une méthode : retrait en euros ou conversion en cadeaux.
            </p>
          </div>

          <button className="retrait-back" onClick={() => navigate("/coffre")}>
            ← Retour Coffre
          </button>
        </div>

        <div className="retrait-panel">
          <div className="retrait-grid">

            {/* 💶 Retrait en euros */}
          <div
            className="retrait-card euros"
            onClick={() => {
            console.log("Retrait euros");
            navigate("/retrait/euros");
          }}
              role="button"
              tabIndex={0}
            >
              <div className="retrait-card-top">
                <div>
                  <div className="retrait-card-icon">💶</div>
                  <h3 className="retrait-card-title">Retrait en euros</h3>
                </div>

                <span className="retrait-chip">Virement • À venir</span>
              </div>

              <p className="retrait-card-desc">
                Convertissez vos coins gagnés en argent réel, avec historique et statut.
              </p>
            </div>

            {/* 🎁 Conversion en cadeaux */}
            <div
           className="retrait-card cadeaux"
            onClick={() => {
           console.log("Conversion cadeaux");
            navigate("/retrait/cadeaux");
            }}

              role="button"
              tabIndex={0}
            >
              <div className="retrait-card-top">
                <div>
                  <div className="retrait-card-icon">🎁</div>
                  <h3 className="retrait-card-title">Conversion en cadeaux</h3>
                </div>

                <span className="retrait-chip">Boutique • À venir</span>
              </div>

              <p className="retrait-card-desc">
                Utilisez vos coins pour envoyer des cadeaux et débloquer des avantages.
              </p>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}
